'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo522x = require('./images/logo52@2x.png');

var _logo522x2 = _interopRequireDefault(_logo522x);

var _wechat_qrcode_bottom = require('./images/wechat_qrcode_bottom02.png');

var _wechat_qrcode_bottom2 = _interopRequireDefault(_wechat_qrcode_bottom);

var _Locale = require('./lang/Locale');

var _Locale2 = _interopRequireDefault(_Locale);

var _base = require('base-64');

var _base2 = _interopRequireDefault(_base);

require('./PCBasicIntroV2.css');

var _user_svip2x = require('./images/user_svip@2x.png');

var _user_svip2x2 = _interopRequireDefault(_user_svip2x);

require('regenerator-runtime/runtime');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

require('url-search-params-polyfill');

var PCGroupIntroV2 = function (_React$Component) {
    _inherits(PCGroupIntroV2, _React$Component);

    function PCGroupIntroV2(props) {
        _classCallCheck(this, PCGroupIntroV2);

        var _this2 = _possibleConstructorReturn(this, (PCGroupIntroV2.__proto__ || Object.getPrototypeOf(PCGroupIntroV2)).call(this, props));

        _this2.state = {
            beianText: '京ICP备18016017号-7',
            companyEnName: 'Beijing Xiaowei Cloud Inc.',
            downloadHost: 'https://download.xdiarys.com',
            downloadFileName: '/windows/xdiarys-setup-v3.exe',
            macOSUrl: '',
            iOSUrl: '',
            helpRecent: [],
            showBeianText: false,
            showHelp: false,

            showPay: false,
            isVip: false,

            contantUsQQWindows: '',
            contantUsQQMacos: '',
            contantUsEmail: 'service@xiaoweiyunfu.com',

            threeMonthPayAmount: 28,
            oneYearPayAmount: 68,
            threeYearPayAmount: 148,

            wechatpayimage: '',
            wechatPayShow: false,
            wechatPayAmount: 0
        };
        return _this2;
    }

    _createClass(PCGroupIntroV2, [{
        key: 'componentWillMount',
        value: function componentWillMount() {

            var search = new URLSearchParams(location.search);
            this.procPayInfo = this.procPayInfo.bind(this);
            this.procPay = this.procPay.bind(this);

            var inweb = search.get("inweb");
            if (inweb != null && inweb == 1) {
                this.setState({ payInWeb: true });
            }

            // 看有没有token，种cookie
            var token = search.get("token");

            if (token && token.length > 0) {
                token = decodeURIComponent(token, true);
                var cookie = _base2["default"].decode(token);
                var arrCookie = cookie.split(";");

                if (arrCookie.length > 0) {
                    this.clearAllCookie();
                }

                for (var i = 0; i < arrCookie.length; i++) {
                    var arr = arrCookie[i].split("=");
                    var key = arr[0];
                    var value = arr[1];

                    if (key && value) {
                        this.setCookie(key, value);
                    }
                }
            }

            // 语言设置
            var paramLang = search.get("lang");
            if (null == paramLang || paramLang.length === 0) {
                //paramLang = "chs";
            }

            var oldUserName = this.getCookieValue('dcufnm');
            var newUserName = oldUserName;
            do {
                oldUserName = newUserName;
                newUserName = decodeURIComponent(oldUserName, true);
            } while (newUserName != oldUserName);

            this.setState({ pay_user: newUserName });

            _Locale2["default"].GetInstance().InitLang(paramLang, navigator.language || navigator.userLanguage);

            var paramTN = search.get("tn");
            if (null != paramTN && paramTN.length > 0) {
                this.setState({ downloadFileName: '/xdiarys_' + paramTN + '.exe' });
            }

            var local = _Locale2["default"].GetInstance();
            document.title = local.getMessagebyId('www_title');

            var lang = local.getLang();
            /*if( lang === 'chs' ) { 
                this.GetContantUs();
                this.setState( {showBeianText:true, showHelp:true, downloadHost: 'https://download.xdiarys.com'} );
            }*/

            var country = 'us';
            if (lang == 'chs') {
                country = 'cn';
            } else if (lang == 'cht') {
                country = 'tw';
            } else if (lang == 'kor') {
                country = 'kr';
            }

            var macOSUrl = 'https://apps.apple.com/' + country + '/app/CalendarTask/id1570563588';
            var iOSUrl = 'https://apps.apple.com/' + country + '/app/CalendarTask/id1570563588?platform=iphone';
            this.setState({ macOSUrl: macOSUrl, iOSUrl: iOSUrl });

            // 获取参数

            var paramRcmd = search.get("rcmd");
            var login = search.get("login");

            this.setState({ paramTN: paramTN, paramRcmd: paramRcmd });

            // 获取超时时间
            var paramExpTime = search.get("exptime");
            if (paramExpTime && paramExpTime.length > 0) {
                var timestamp = Date.parse(paramExpTime);
                var curTimestamp = Date.parse(new Date());
                var diffDay = (timestamp - curTimestamp) / (1000 * 60 * 60 * 24);
                diffDay = Math.floor(diffDay);

                if (diffDay > 0 && diffDay <= 30) {
                    this.setState({ expTime: paramExpTime, showExpTime: true });
                }
            }

            if (login == '1') {
                this.listenPay();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var search, login, response, retObj, vData, src;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                search = new URLSearchParams(location.search);
                                login = search.get("login");

                                if (!(login == '1')) {
                                    _context.next = 16;
                                    break;
                                }

                                _context.prev = 3;
                                _context.next = 6;
                                return fetch('/api/users/account/info', {
                                    method: 'GET',
                                    credentials: 'include',
                                    headers: {
                                        'Accept': 'application/json, text/plain, */*'
                                    }
                                });

                            case 6:
                                response = _context.sent;
                                _context.next = 9;
                                return response.json();

                            case 9:
                                retObj = _context.sent;


                                if (retObj.result === 1) {
                                    vData = retObj.vdata;

                                    this.setState({ isVip: vData.vip || false });
                                }
                                _context.next = 16;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](3);

                                console.error('Error fetching account info:', _context.t0);

                            case 16:
                                src = search.get("src");

                                if (src === 'web') {
                                    this.setState({ showPay: false });
                                } else if (src === 'macos' || src === 'windows') {
                                    if (login == '0') {
                                        this.setState({ showPay: false });
                                    } else if (login == '1') {
                                        this.setState({ showPay: true });
                                    }
                                }
                                console.log("isVip", this.state.isVip);
                                console.log("showPay", this.state.showPay);

                            case 20:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[3, 13]]);
            }));

            function componentDidMount() {
                return _ref.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'GetContantUs',
        value: function GetContantUs() {
            var _this = this;

            fetch('/api/help/contantus', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {

                _this.setState({ contantUsQQWindows: myJson.vdata.qqwindow });
                _this.setState({ contantUsQQMacos: myJson.vdata.qqmacos });
                _this.setState({ contantUsEmail: myJson.vdata.email });

                return myJson;
            })["catch"](function (e) {
                console.log(e);
            });
        }
    }, {
        key: 'breakLine',
        value: function breakLine(text) {
            var br = _react2["default"].createElement('br');
            var regex = /(<br \/>)/g;
            return text.split(regex).map(function (line, index) {
                alert(text);
                return line.match(regex) ? _react2["default"].createElement('br', { key: "key_" + index }) : line;
            });
        }
    }, {
        key: 'listenPay',
        value: function listenPay() {
            var urlWeb = this.getWebSocketUrl();
            var urlAccont = this.getAccountUrl();
            var _this = this;

            try {
                var ws = new WebSocket(urlWeb);
                ws.onmessage = function (e) {
                    try {
                        var obj = JSON.parse(e.data);
                        if (obj.type === 'pay') {
                            if (_this.state.payInWeb) {
                                window.location.href = urlAccont;
                            } else {
                                window.close();
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                };
            } catch (error) {
                console.log(error);
            }
        }
    }, {
        key: 'getWebSocketUrl',
        value: function getWebSocketUrl() {
            var nIndex = this.getPayIndex();
            var ishttps = 'https:' == document.location.protocol ? true : false;

            var webSocketProtocol = ishttps ? 'wss' : 'ws';
            var url = webSocketProtocol + '://notification.xdiarys.com/ws?pcname=web';
            if (nIndex > 0) {
                url = webSocketProtocol + '://notification' + nIndex + '.xdiarys.com/ws?pcname=web';
            }
            return url;
        }
    }, {
        key: 'getPayIndex',
        value: function getPayIndex() {
            if ('pay.xdiarys.com' == location.host) {
                return 0;
            } else if ('pay1.xdiarys.com' == location.host) {
                return 1;
            } else if ('pay2.xdiarys.com' == location.host) {
                return 2;
            } else {
                return 0;
            }
        }
    }, {
        key: 'getAccountUrl',
        value: function getAccountUrl() {
            var nIndex = this.getPayIndex();
            var url = 'https://account.xdiarys.com';
            if (nIndex > 0) {
                url = 'https://account' + nIndex + '.xdiarys.com';
            }
            return url;
        }
    }, {
        key: 'setCookie',
        value: function setCookie(name, value, seconds) {
            seconds = seconds || 0; //seconds有值就直接赋值，没有为0，这个根php不一样。
            var expires = "";
            if (seconds != 0) {
                //设置cookie生存时间
                var date = new Date();
                date.setTime(date.getTime() + seconds * 1000);
                expires = "; expires=" + date.toGMTString();
            }
            document.cookie = name + "=" + escape(value) + expires + "; path=/"; //转码并赋值
        }
    }, {
        key: 'getCookieValue',
        value: function getCookieValue(c_name) {
            if (document.cookie.length > 0) {
                //判断cookie是否存在
                //获取cookie名称加=的索引值
                var c_start = document.cookie.indexOf(c_name + "=");
                if (c_start !== -1) {
                    //说明这个cookie存在
                    //获取cookie名称对应值的开始索引值
                    c_start = c_start + c_name.length + 1;
                    //从c_start位置开始找第一个分号的索引值，也就是cookie名称对应值的结束索引值
                    var c_end = document.cookie.indexOf(";", c_start);
                    //如果找不到，说明是cookie名称对应值的结束索引值就是cookie的长度
                    if (c_end === -1) c_end = document.cookie.length;
                    //unescape() 函数可对通过 escape() 编码的字符串进行解码
                    //获取cookie名称对应的值，并返回
                    return document.cookie.substring(c_start, c_end);
                }
            }
            return ""; //不存在返回空字符串
        }
    }, {
        key: 'clearAllCookie',
        value: function clearAllCookie() {
            var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
            if (keys) {
                for (var i = keys.length; i--;) {
                    document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
                }
            }
        }
    }, {
        key: 'changePayAmount1',
        value: function changePayAmount1() {
            this.setState({ radioChecked: 1, showQR: false, disablePaypalButton: true, wechatPayAmount: this.state.threeMonthPayAmount });
        }
    }, {
        key: 'changePayAmount2',
        value: function changePayAmount2() {
            this.setState({ radioChecked: 2, showQR: false, disablePaypalButton: true, wechatPayAmount: this.state.oneYearPayAmount });
        }
    }, {
        key: 'changePayAmount3',
        value: function changePayAmount3() {
            this.setState({ radioChecked: 3, showQR: false, disablePaypalButton: true, wechatPayAmount: this.state.threeYearPayAmount });
        }
    }, {
        key: 'getCheckedInfo',
        value: function getCheckedInfo() {
            var checksum_ts = 0;
            var checksum_val = "";
            var pay_days = 0;

            if (this.state.radioChecked === 1) {
                checksum_ts = this.state.c_checksum_ts_1;
                checksum_val = this.state.c_checksum_val_1;
                pay_days = this.state.pay_days_1;
            } else if (this.state.radioChecked === 2) {
                checksum_ts = this.state.c_checksum_ts_2;
                checksum_val = this.state.c_checksum_val_2;
                pay_days = this.state.pay_days_2;
            } else if (this.state.radioChecked === 3) {
                checksum_ts = this.state.c_checksum_ts_3;
                checksum_val = this.state.c_checksum_val_3;
                pay_days = this.state.pay_days_3;
            }

            return { 'ts': checksum_ts, 'val': checksum_val, 'days': pay_days };
        }
    }, {
        key: 'onUpgradeGroupVip',
        value: function onUpgradeGroupVip() {
            window.location.href = 'https://pay.xdiarys.com/group?inweb=1';
        }
    }, {
        key: 'onClickPayPal',
        value: function onClickPayPal(e) {
            var _this = this;
            this.setPaypalInfo(function (order) {
                if (order) {
                    _this.refs.paypalform.submit();
                } else {
                    alert("Get Order Error");
                }
            });
        }
    }, {
        key: 'onHideQR',
        value: function onHideQR(e) {
            this.setState({ showQR: false });
        }
    }, {
        key: 'procPay',
        value: function procPay(res) {
            if (res && res.vdata && res.vdata.order && res.vdata.order.pay_img) {
                var imagebase64 = res.vdata.order.pay_img;
                imagebase64 = 'data:image/png;base64,' + imagebase64;
                this.setState({ wechatpayimage: imagebase64, wechatPayShow: true });
            }
        }
    }, {
        key: 'procPayInfo',
        value: function procPayInfo(res) {
            var _this3 = this;

            if (res && res.vdata && res.vdata.list) {

                var list = res.vdata.list;

                list.forEach(function (item) {

                    if (item.pay_days == 90) {
                        _this3.setState({ threeMonthPayAmount: item.pay_amount,
                            pay_days_1: item.pay_days,
                            c_checksum_ts_1: item.c_checksum_ts,
                            c_checksum_val_1: item.c_checksum_val
                        });
                    } else if (item.pay_days == 365) {
                        _this3.setState({ oneYearPayAmount: item.pay_amount,
                            pay_days_2: item.pay_days,
                            c_checksum_ts_2: item.c_checksum_ts,
                            c_checksum_val_2: item.c_checksum_val
                        });
                    } else if (item.pay_days == 1095) {
                        _this3.setState({ threeYearPayAmount: item.pay_amount,
                            pay_days_3: item.pay_days,
                            c_checksum_ts_3: item.c_checksum_ts,
                            c_checksum_val_3: item.c_checksum_val
                        });
                    }
                });

                this.changePayAmount3();
            }
        }
    }, {
        key: 'render',
        value: function render() {

            var local = _Locale2["default"].GetInstance();

            var upgradeButton = local.getMessagebyId('group_upgrade_button');

            var titleText = local.getMessagebyId('group_title');

            var lang = local.getLang();
            var intro_image1;
            var intro_image2;
            var intro_image3;

            if (lang === 'chs') {
                intro_image1 = require('./images/groupintro/www_1_group_chs.png');
                intro_image2 = require('./images/groupintro/www_2_group_chs.png');
                intro_image3 = require('./images/groupintro/www_3_group_chs.png');
            } else if (lang === 'kor') {
                intro_image1 = require('./images/groupintro/www_1_group_kor.png');
                intro_image2 = require('./images/groupintro/www_2_group_kor.png');
                intro_image3 = require('./images/groupintro/www_3_group_kor.png');
            } else if (lang === 'usa') {
                intro_image1 = require('./images/groupintro/www_1_group_usa.png');
                intro_image2 = require('./images/groupintro/www_2_group_usa.png');
                intro_image3 = require('./images/groupintro/www_3_group_usa.png');
            } else if (lang === 'cht') {
                intro_image1 = require('./images/groupintro/www_1_group_cht.png');
                intro_image2 = require('./images/groupintro/www_2_group_cht.png');
                intro_image3 = require('./images/groupintro/www_3_group_cht.png');
            }

            var support = local.getMessagebyId('support');
            var support_text1 = local.getMessagebyId('support_text1');
            var support_text4 = local.getMessagebyId('support_text4');
            var about_us = local.getMessagebyId('about_us');
            var help = local.getMessagebyId('help');

            var arrbaseIntroImage = [];
            arrbaseIntroImage.push({ id: 'group_intro_1', title: local.getMessagebyId('group_intro_title1'), subtitle: local.getMessagebyId('group_intro_subtitle1'), content: local.getMessagebyId('group_intro_text1'), image: intro_image1, vip: true });
            arrbaseIntroImage.push({ id: 'group_intro_2', title: local.getMessagebyId('group_intro_title2'), subtitle: local.getMessagebyId('group_intro_subtitle2'), content: local.getMessagebyId('group_intro_text2'), image: intro_image2, vip: true });
            arrbaseIntroImage.push({ id: 'group_intro_3', title: local.getMessagebyId('group_intro_title3'), subtitle: local.getMessagebyId('group_intro_subtitle3'), content: local.getMessagebyId('group_intro_text3'), image: intro_image3, vip: true });
            //  arrbaseIntroImage.push({ id : 'group_intro_4', title: local.getMessagebyId('group_intro_title4'),  subtitle: local.getMessagebyId('group_intro_subtitle4'), content: local.getMessagebyId('group_intro_text4'), image: intro_image3, vip: true });


            //循环用到的初始变量
            var icoIndex = 0;
            var featureType = "";

            var bindClass = "bi-v2-top-bind h70";
            var emptyClass = "bi-v2-top-empty h70";

            //底部版权信息
            var ico_mail = require('./images/indexV2/ico-mail.png');
            var copy_right = local.getMessagebyId('copy_right');

            return _react2["default"].createElement(
                'div',
                { className: 'bi-v2-html' },
                _react2["default"].createElement(
                    'div',
                    { className: 'bi-v2-all' },
                    _react2["default"].createElement(
                        'div',
                        { className: bindClass },
                        _react2["default"].createElement(
                            'div',
                            { className: 'bi-v2-top' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'bi-v2-top-contain' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'w45 float-left aling-left logo-area' },
                                    _react2["default"].createElement('img', { className: 'logo', src: require('./images/baseintrov2/logo.png') }),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'logo-text' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'logo-title' },
                                            local.getMessagebyId('www_title')
                                        ),
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'logo-sub-title' },
                                            local.getMessagebyId('v2_sub_title')
                                        )
                                    )
                                ),
                                this.state.showPay ? _react2["default"].createElement(
                                    'div',
                                    { className: 'v2-pay-btn float-right' },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'pay-btn mt--5', onClick: this.onUpgradeGroupVip.bind(this) },
                                        local.getMessagebyId('v2_pay_btn_text')
                                    )
                                ) : _react2["default"].createElement(
                                    'div',
                                    { className: 'v2-more-area float-right' },
                                    _react2["default"].createElement(
                                        'span',
                                        { className: 'more-link' },
                                        _react2["default"].createElement(
                                            'a',
                                            { href: 'https://www.xdiarys.com/' },
                                            local.getMessagebyId('v2_www_link')
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2["default"].createElement('div', { className: emptyClass }),
                    _react2["default"].createElement(
                        'div',
                        { className: 'bi-item-list' },
                        arrbaseIntroImage.map(function (item, index) {
                            //顺序ico
                            icoIndex = icoIndex + 1;

                            //css 左右切换
                            var classIndex = "1";
                            if (index % 2 == 1) {
                                classIndex = "2";
                            }

                            var xClass = "bi-item-row bg-row" + classIndex;
                            xClass = xClass + " br" + classIndex + "-bg-vip";
                            var featureTypeText = local.getMessagebyId('v2_feature_team_text');

                            //顺序ico图
                            var icoImg = require('./images/baseintrov2/row-ico' + icoIndex + '.png');

                            return _react2["default"].createElement(
                                'div',
                                { className: xClass, id: item.key },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'bi-item-block', id: item.id },
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'item-block-img' },
                                        _react2["default"].createElement('img', { src: item.image })
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'item-block-text' },
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'ibt-title' },
                                            _react2["default"].createElement(
                                                'span',
                                                { className: 'ibt-title-text' },
                                                item.title,
                                                _react2["default"].createElement('span', { className: 'ibt-title-bg' })
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'div',
                                            { className: 'ibt-subtitle' },
                                            item.subtitle
                                        ),
                                        _react2["default"].createElement('div', { className: 'ibt-content',
                                            dangerouslySetInnerHTML: {
                                                __html: item.content
                                            }
                                        })
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'item-block-ico' },
                                        _react2["default"].createElement('img', { src: icoImg })
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'item-block-type' },
                                        _react2["default"].createElement(
                                            'span',
                                            { className: 'type-text' },
                                            featureTypeText
                                        )
                                    )
                                )
                            );
                        })
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'v2-bottom' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'bottom-area' },
                            this.state.showLinkArea ? null : _react2["default"].createElement(
                                'div',
                                { className: 'bottom-link' },
                                _react2["default"].createElement('img', { src: ico_mail, className: 'link-ico', alt: 'Email' }),
                                ' ',
                                this.state.contantUsEmail
                            ),
                            copy_right,
                            ' \xA0',
                            this.state.companyEnName,
                            '  ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'privacypolicy' },
                                'Privacy Policy'
                            ),
                            ' / ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'eula' },
                                'EULA'
                            ),
                            this.state.showBeianText ? _react2["default"].createElement(
                                'span',
                                { className: 'beian' },
                                '\xA0\xA0\xA0|\xA0\xA0\xA0 ',
                                _react2["default"].createElement(
                                    'a',
                                    { className: 'link', href: 'http://beian.miit.gov.cn/' },
                                    ' ',
                                    this.state.beianText
                                )
                            ) : null
                        )
                    )
                )
            );
        }
    }]);

    return PCGroupIntroV2;
}(_react2["default"].Component);

exports["default"] = PCGroupIntroV2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./PCGroupIntroV2.js
// module id = 627
// module chunks = 0